/**
 * custom-collection-title-overload.js
 *
 * Detects whether text in .card__heading is truncated (overflow: hidden +
 * fixed height) and, if so, adds an icon that expands the text on hover.
 * Also works for elements added dynamically (e.g. via AJAX) via MutationObserver.
 */
(() => {
    // ---- Config ----
    const SELECTOR = '.card__heading';
    const TOGGLE_CLASS = 'card__heading-toggle';
    const EXPANDED_CLASS = 'is-expanded';
    const CHECKED_ATTR = 'data-toggle-checked';
  
    // ---- Detect overflow and inject the toggle icon ----
    function initCardHeadingToggle(container = document) {
      const headings = container.querySelectorAll(`${SELECTOR}:not([${CHECKED_ATTR}])`);
      headings.forEach((heading) => {
        heading.setAttribute(CHECKED_ATTR, 'true');
        const headingTitle = heading.querySelector('a')
        if(!headingTitle) return
        const isOverflowing = headingTitle.scrollHeight > heading.clientHeight;
        if (isOverflowing && !heading.querySelector(`.${TOGGLE_CLASS}`)) {
          heading.appendChild(buildToggleIcon());
        }
      });
    }
  
    function buildToggleIcon() {
      const toggle = document.createElement('span');
      toggle.className = `${TOGGLE_CLASS} is-visible`;
      toggle.innerHTML = '&#9662;';
      return toggle;
    }
  
    // ---- Hover delegation (mouseenter/mouseleave don't bubble, hence capture: true) ----
    function handleHoverToggle(event, isEntering) {
      if (!event.target.classList?.contains(TOGGLE_CLASS)) return;
  
      const heading = event.target.closest(SELECTOR);
      heading?.classList.toggle(EXPANDED_CLASS, isEntering);
    }
  
    document.addEventListener('mouseenter', (e) => handleHoverToggle(e, true), true);
    document.addEventListener('mouseleave', (e) => handleHoverToggle(e, false), true);
  
    // ---- MutationObserver: catch cards added dynamically (e.g. after AJAX) ----
    function startObserver() {
      const observer = new MutationObserver((mutations) => {
        const hasNewHeading = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some(
            (node) => node.nodeType === 1 && (node.matches?.(SELECTOR) || node.querySelector?.(SELECTOR))
          )
        );

        if (hasNewHeading) initCardHeadingToggle();
      });
  
      observer.observe(document.body, { childList: true, subtree: true });
    }
  
    // ---- Start ----
    function start() {
      initCardHeadingToggle();
      startObserver();
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();